// The db-select-theme.module.css rules only apply when a react-select instance
// sets this classNamePrefix. Components that render a db-select import the
// stylesheet directly so it can never be tree-shaken out from under them.
export const DB_SELECT_CLASS_NAME_PREFIX = 'db-select';
